import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { Logs } from '@sloyd/ui';
import { useEffect, useMemo } from 'react';
import { useKey } from 'react-use';

export type LogsContainerProps = {};

export function LogsContainer(_props: LogsContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const logs = useSelector(selectors.base.$logs);
  const { showLogs } = appState;

  const callbacks = useMemo(
    () => ({
      clearLogs: () => {
        dispatch(actions.logs.setAll({}));
      },
    }),
    []
  );

  useKey(
    '`',
    () => {
      const isInIframe = window.parent !== window;
      if (isInIframe) return;

      dispatch(
        actions.appState.patch({
          showLogs: !showLogs,
        })
      );
    },
    {},
    [showLogs]
  );

  useEffect(() => {
    if (showLogs) {
      // @ts-ignore
      window.debugBridge = true;
    }
  }, [showLogs]);

  if (!showLogs) {
    return false;
  }

  return <Logs logs={logs} callbacks={callbacks} />;
}

export default LogsContainer;
